import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { apr } from '@cred/shared/formatters'

import Superscript from 'components/RateTableFooterDisclosure/Superscript'
import { loadLendersRates } from 'common/utils/rates'
import { getCtaUrl } from 'personal-loan/rate-table/utils'
import HeaderCTA from 'components/header-CTA'
import withRateScript from 'components/hocs/with-rate-script'

import { PERSONAL_LOAN_HEADER_TEXT } from '../../constants'
import styles from './styles.module.scss'

const DefaultHeader = ({
  isScriptLoaded,
  availableLenders,
  embeddedWidgetQueryParams,
  showRateTableAsFirstPrequalStep = false,
  setIsDisclosureOpen = () => {},
}) => {
  const minRate = useMemo(() => {
    if (isScriptLoaded) {
      const lendersWithRates = loadLendersRates({
        availableLenders,
        filters: { vertical: 'personal' },
      })

      return lendersWithRates[0]?.minFixedRate
    }
    return null
  }, [isScriptLoaded, availableLenders])

  return (
    <div className={styles.headerWrap}>
      <div>
        <p className={cx(styles.header, 'mb-8 heading bold')}>{PERSONAL_LOAN_HEADER_TEXT}</p>
        <p className={styles.subheader}>
          Personal loan rates from {apr(minRate)} fixed APR
          <Superscript callback={() => setIsDisclosureOpen(true)} />
        </p>
      </div>
      <HeaderCTA
        ctaUrl={getCtaUrl({ embeddedWidgetQueryParams, showRateTableAsFirstPrequalStep })}
        blank={!showRateTableAsFirstPrequalStep}
        btnText="2 Min: Check Rates"
      />
    </div>
  )
}

DefaultHeader.propTypes = {
  isScriptLoaded: PropTypes.bool.isRequired,
  availableLenders: PropTypes.instanceOf(Array).isRequired,
  embeddedWidgetQueryParams: PropTypes.string.isRequired,
  setIsDisclosureOpen: PropTypes.func,
  showRateTableAsFirstPrequalStep: PropTypes.bool,
}

export { DefaultHeader as DefaultHeaderNoHoc }
export default withRateScript(DefaultHeader)
